import React, { useState, useEffect } from "react";
import Loader from "../Loader/Loader";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MdSearch, MdAdd, MdOutlineContentCopy, MdEdit } from "react-icons/md";
import Button from "react-bootstrap/Button";
import { Link, useNavigate } from "react-router-dom";
import { GetMarketplaceBusinessListApi } from "../API/Coupons/GetMarketplaceBusinessListApi";
import Pagination from "../Pagination/Pagination";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import SearchBarResults from "../Search/SearchBarResults";
import { useDebounce } from "../../Utils/hooks/useDebounce";

const BussinessListing = () => {
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [businessList, setBusinessList] = useState([]);
  const [sortBy, setSortBy] = useState("created_at");
  const [sortOrder, setSortOrder] = useState(-1);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const serchWithDebounce = useDebounce(handleSearch, 700);


  const navigate = useNavigate();

  const getBusinessList = async (pageNo = 1) => {
    setLoading(true);

    const payload = {
      page: pageNo,
      page_size: limit,
      sort_by: sortBy,
      sort_order: sortOrder,
    };

    const res = await GetMarketplaceBusinessListApi(payload,()=>{
      navigate("/");
    });

    if (res?.success) {
      setBusinessList(res.data);

      // API values
      setTotalPageCount(res.total);
      setLimit(res.page_size);
    }

    setLoading(false);
  };
  useEffect(() => {
    getBusinessList(pageNumber + 1);
  }, [pageNumber, sortBy, sortOrder]);

  const handleSearchInput = (e) => {
    setSearchValue(e.target.value);
    serchWithDebounce(e.target.value);
  };

  const handleKeypress = (e) => {
    if (e.code === "Enter") {
      handleSearch();
    }
  };

  async function handleSearch(searchValue) {
    setLoading(true);

    const data = {
      search: searchValue,
    };
    const response = await GetMarketplaceBusinessListApi(data,()=>{
      navigate("/");
    });

    if (response.status) {
      setBusinessList(response.data);
      setTotalPageCount(response.total);
      setLimit(response.page_size);
      setLoading(false);
    }
  }

  const [sortConfig, setSortConfig] = useState({
    business_name: 0,
    created_at: 0,
  });

  const handleSort = (column) => {
    const order = sortOrder === -1 ? 1 : -1;

    setSortBy(column);
    setSortOrder(order);

    setSortConfig({
      business_name: 0,
      created_at: 0,
      [column]: order === 1 ? 1 : -1,
    });
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="manage-vou-main pt-3  three-col-heading">
        <p className="page-maintitle pt-1">Manage Bussiness</p>
        <div className="">
          <div className="">
            <InputGroup className="search-bar MVouchers">
              <InputGroup.Text>
                <MdSearch />
              </InputGroup.Text>
              <Form.Control
                className="search_feild"
                value={searchValue}
                onChange={(e) => handleSearchInput(e)}
                onKeyPress={handleKeypress}
                placeholder="Search Business"
              />
              <Button variant="outline-secondary" onClick={handleSearch}>
                Search
              </Button>
            </InputGroup>
            <SearchBarResults SearchValue={searchValue} />
          </div>
        </div>
        <div className="manage-vou d-flex">
          <Link
            to="/coupons/bussiness-listing/create-bussiness"
            className="toggle-option active m-2"
          >
            <MdAdd /> Create Business
          </Link>
        </div>

        {/* ---Table--- */}
      </div>
      {/* <div className="flex justify-end items-center gap-1 mb-3">
        <MdOutlineContentCopy fill="#E66100" />
        <p>To copy/clone the Business</p>
      </div> */}
      {/* <p>search result</p> */}

      <div className="table-responsive-xl black-header">
        <table className="recentact-table mt-3 table ver-middle manage-vou-table">
          <thead>
            <tr>
              <th
                onClick={() => handleSort("business_name")}
                style={{ textAlign: "left", width: "20%" }}
              >
                <Button className="btn btn-primary sortIcon">
                  Business Name
                  {sortConfig.business_name === 0 ? (
                    <FaSort />
                  ) : sortConfig.business_name === 1 ? (
                    <FaSortUp />
                  ) : (
                    <FaSortDown />
                  )}
                </Button>
              </th>

              <th style={{ textAlign: "center" }}>Contact</th>

              <th style={{ textAlign: "center" }}> Email</th>

              <th style={{ textAlign: "center" }}>Category</th>

              <th
                onClick={() => handleSort("created_at")}
                style={{ textAlign: "center" }}
              >
                {/* <Button className="btn btn-primary sortIcon">
                  Created Date
                  {sortConfig.created_at === 0 ? (
                    <FaSort />
                  ) : sortConfig.created_at === 1 ? (
                    <FaSortUp />
                  ) : (
                    <FaSortDown />
                  )}
                </Button> */}
                Created Date
              </th>

              <th style={{ textAlign: "center" }}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {businessList?.length > 0 ? (
              businessList.map((item) => (
                <tr key={item.mb_id}>
                  <td className="text-left blue-underline-text">
                    <Link
                      to={`/coupons/bussiness-listing/view-business/${item.mb_id}`}
                    >
                      {item.business_name}
                    </Link>{" "}
                  </td>

                  <td style={{ textAlign: "center" }}>{item.contact}</td>

                  <td style={{ textAlign: "center" }}>{item.primary_email}</td>

                  <td style={{ textAlign: "center" }}>{item.category_name}</td>

                  <td style={{ textAlign: "center" }}>{item.created_at}</td>

                  <td style={{ textAlign: "center" }}>
                    <Link
                      to={`/coupons/bussiness-listing/edit-business/${item.mb_id}`}
                    >
                      <MdEdit
                        size={20}
                        fill="#E66100"
                        style={{ cursor: "pointer" }}
                        title="Clone"
                      />
                    </Link>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>
                  No Business Found
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {businessList?.length > 0 && (
          <Pagination
            totalPageCount={totalPageCount}
            setPageNumber={setPageNumber}
            limit={limit}
          />
        )}
      </div>
    </>
  );
};

export default BussinessListing;
